import {Component, Input} from "@angular/core";

/**
 * A component that renders an SVG icon for "Tune Variant"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-tune-variant',
    templateUrl: './icon-tune-variant.component.html',
    styleUrls: ['./icon-tune-variant.component.scss'],
    standalone: false
})
export class IconTuneVariantComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
